import { render, staticRenderFns } from "./BrQuestionsContent.vue?vue&type=template&id=75eac4d4&"
import script from "./BrQuestionsContent.vue?vue&type=script&lang=js&"
export * from "./BrQuestionsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports